import { Feature } from 'src/WebApiController';

import { ReportColumnPersonalizationFlags } from '../columnUtils.types';
import {
  SaleLineItemReportTableGroupingColumnId,
  SaleLineItemReportTableValueColumnId,
} from './saleLineItemColumnUtils.types';

export const SALE_LINE_ITEM_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [SaleLineItemReportTableGroupingColumnId.EventDateLocal]: {
    isDateTime: true,
  },
  [SaleLineItemReportTableGroupingColumnId.SellerAccountCurrencyCode]: {
    requiredFeatures: [Feature.AlignCurrenciesOnReports],
  },
  [SaleLineItemReportTableValueColumnId.Cost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SaleLineItemReportTableValueColumnId.Credit]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SaleLineItemReportTableValueColumnId.Charge]: {
    isNumeric: true,
    isCurrency: true,
  },
};
